import React, { useEffect, useState } from "react";
import Card from "@components/Card";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import {
  cardStyles,
  HeadingContainer,
  Heading,
  CardContent,
  Dot,
  GridDetailsContainer,
  GridFieldContainer,
  GridItem,
  FieldName,
  FieldValue,
  Divider,
  EditCta,
  MinifiedDetailsValue,
  EditSection
} from "./styles";

import DOMPurify from "isomorphic-dompurify";
import ImageContainer from "@components/imageContainer";
import {
  BulletMinifiedDetails,
  LinkText,
  StyledText
} from "@widgets/ExpandableCard/styles";
import { EditContainer } from "@components/Edit/styles";
import actionsMap from "@actions/actionsMap";
import { useOnload } from "@utils/useOnLoad";
import { sampleAnalytics } from "@utils/index";
import { resolvePath } from "@utils/resolvePath";
import {
  FuelType,
  FUEL_TYPE_DISPLAY_MAP,
  FUEL_TYPES_TO_CAPITALIZE
} from "@utils/constants";

export interface Vehicledetails {
  text: string;
  style: Style;
  allowEdit: boolean;
  cardTitle: string;
  ownerData?: OwnerDataEntity[] | null;
  is_visible: boolean;
  headingIcon: string;
  showDetails: boolean;
  vehicleData?: VehicleDataEntity[] | null;
  editDetailsIcon: string;
  editDetailsText: string;
  minifiedDetails?: MinifiedDetailsEntity[] | null;
  minifiedLinkText: string;
  editDetailsAction: EditDetailsAction;
  expandableLinkText: string;
}
export interface Style {}
export interface OwnerDataEntity {
  field: string;
  value: string;
  maskedValue?: string | null;
  fullWidth?: boolean | null;
}
export interface VehicleDataEntity {
  field: string;
  value: string;
  make?: string | null;
  type?: string | null;
  model?: string | null;
}
export interface MinifiedDetailsEntity {
  type: string;
  value?: string | ValueEntity[] | null;
  styles?: Styles | null;
}
export interface ValueEntity {
  make?: string | null;
  type: string;
  model?: string | null;
  value: string;
  styles: Styles1;
}
export interface Styles1 {
  fontWeight: number;
}
export interface Styles {
  fontWeight: number;
}
export interface EditDetailsAction {
  on_click?: OnClickEntity[] | null;
}
export interface OnClickEntity {
  args: Args;
  type: string;
}
export interface Args {
  requestBody: RequestBody;
}
export interface RequestBody {
  current_node: string;
  expected_node: string;
}

const VehicleDetails = ({ ...props }: any) => {
  const {
    cardTitle,
    editDetailsIcon,
    editDetailsText,
    expandableLinkText,
    headingIcon,
    minifiedLinkText,
    vehicleData,
    ownerData,
    minifiedDetails,
    allowEdit,
    editDetailsAction,
    actions,
    showDetails
  } = props;
  const { on_load } = actions || {};

  useOnload({ on_load });

  const handleActionClick = (on_click) => {
    on_click?.forEach((act) => {
      const setterFxn = actionsMap?.[act?.type];
      if (act && typeof setterFxn === "function") {
        setterFxn(act?.args || {});
      }
    });
  };

  const formatFuelType = (value: string): string => {
    if (value === FuelType.INTERNAL_LPG_CNG) {
      return FUEL_TYPE_DISPLAY_MAP[FuelType.INTERNAL_LPG_CNG];
    }
    if (FUEL_TYPES_TO_CAPITALIZE.includes(value as FuelType)) {
      return FUEL_TYPE_DISPLAY_MAP[value as FuelType] || value;
    }
    return value;
  };

  const getStyledtextJsx = (item) => {
    return (
      <StyledText styles={item?.styles}>
        {DOMPurify.sanitize(item?.value)}
      </StyledText>
    );
  };
  const getBulletMinifiedDetails = (bulletMinifiedDetails) => {
    return (
      <Flex
        flexDirection="row"
        styles={{ alignItems: "center", gap: "0.5rem" }}
      >
        {bulletMinifiedDetails?.map((item, idx) => {
          return (
            <>
              <StyledText styles={item?.styles}>
                {item?.type === "makemodel"
                  ? `${item?.make} ${item?.model}`
                  : DOMPurify.sanitize(
                      item?.value === "internal_lpg_cng" ? "CNG" : item?.value
                    )}
              </StyledText>
              {idx < bulletMinifiedDetails?.length - 1 && <Dot />}
            </>
          );
        })}
      </Flex>
    );
  };
  const GetJsxForType = ({ type, item }) => {
    console.log("here final lol", type, item);
    switch (type) {
      case "text":
        console.log("here final lol inside", type, item);
        return getStyledtextJsx(item);
      case "bulletMinifiedDetails":
        return (
          <BulletMinifiedDetails>
            {getBulletMinifiedDetails(item?.value)}
          </BulletMinifiedDetails>
        );
      default:
        return <></>;
    }
  };

  const RenderMinifiedDetails = ({ minifiedDetails }) => {
    console.log("here lol", minifiedDetails);
    return minifiedDetails?.map((detailItem) => {
      return <GetJsxForType type={detailItem?.type} item={detailItem} />;
    });
  };

  const RenderDetails = (item) => {
    const getItemDisplayValue = (item) => {
      if (item?.type === "makemodel") {
        return `${item?.make} ${item?.model}`;
      }

      if (typeof item?.value === "boolean") {
        return item?.value ? "Yes" : "No";
      }

      return DOMPurify.sanitize(formatFuelType(item?.value));
    };
    return item?.value || item?.type === "makemodel" ? (
      <GridItem fullWidth={item?.fullWidth}>
        <GridFieldContainer>
          <FieldName>{item.field}</FieldName>
          <FieldValue>{getItemDisplayValue(item)}</FieldValue>
        </GridFieldContainer>
      </GridItem>
    ) : null;
  };

  return (
    <Card
      styles={cardStyles({
        show: showDetails,
        styles: { marginTop: "4px" }
      })}
    >
      <HeadingContainer
        onClick={(e) => {
          e.stopPropagation();
          // if (!disableToggle) {
          //   setShowDetails && setShowDetails(!showDetails);
          //   arrowClickHandler && arrowClickHandler();
          // }
        }}
        showDetails={showDetails}
      >
        <Flex
          alignItems="center"
          styles={{ boxSizing: "border-box", gap: "8px", width: "auto" }}
        >
          {/* todo: change hardcoded true  */}
          {headingIcon && (
            <ImageContainer
              imgSrc={headingIcon}
              height={24}
              width={24}
              style={{ marginRight: "0.5rem" }}
            />
          )}
          <Heading>{cardTitle} </Heading>
        </Flex>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            boxSizing: "border-box"
          }}
        >
          <EditSection
            onClick={() => handleActionClick(editDetailsAction?.on_click)}
          >
            <ImageContainer imgSrc={editDetailsIcon} height={20} width={20} />{" "}
          </EditSection>
        </div>
      </HeadingContainer>

      <div
        style={{
          transition: "max-height 0.3s cubic-bezier(0.4, 0, 1, 1) 0s",
          maxHeight: showDetails ? "1000px" : "200px",
          overflow: "hidden"
        }}
      >
        <CardContent showDetails={showDetails}>
          {showDetails ? (
            <>
              <GridDetailsContainer>
                {vehicleData?.map((d) => {
                  return RenderDetails(d);
                })}
              </GridDetailsContainer>

              <Divider style={{ height: "1px" }} />

              <GridDetailsContainer>
                {ownerData?.map((d) => {
                  return d?.value ? (
                    <GridItem fullWidth={d?.fullWidth}>
                      <GridFieldContainer>
                        <FieldName>{d.field}</FieldName>
                        <FieldValue>{d.maskedValue || d.value}</FieldValue>
                      </GridFieldContainer>
                    </GridItem>
                  ) : (
                    <></>
                  );
                })}
              </GridDetailsContainer>
            </>
          ) : (
            <Flex flexDirection="column">
              <RenderMinifiedDetails minifiedDetails={minifiedDetails} />
            </Flex>
          )}
        </CardContent>
      </div>
    </Card>
  );
};

export default VehicleDetails;
